import { atom } from "jotai";

import { type ResourceContainer } from "../../gql-generated/types";
import { getDefaultOrganizationContainerV2, makeAllContainersMapV2 } from "../context/organizations-mappingsV2";

export const organizationsV2DataAtom = atom<ResourceContainer[]>([]);

export const defaultOrganizationIdV2Atom = atom<string | undefined>();

export const organizationsV2LoadingAtom = atom<boolean>(true);

export const organizationsV2ErrorAtom = atom<Error | undefined>();

export const organizationsV2RefetchAtom = atom<number>(0);

export const organizationsV2InitializedAtom = atom<boolean>(false);

export const containersIndexV2Atom = atom((get) => {
    const organizations = get(organizationsV2DataAtom);
    return makeAllContainersMapV2(organizations);
});

export const defaultOrganizationContainerV2Atom = atom((get) => {
    const organizations = get(organizationsV2DataAtom);
    const defaultOrganizationId = get(defaultOrganizationIdV2Atom);

    return getDefaultOrganizationContainerV2(organizations, defaultOrganizationId ?? "");
});

export const organizationsV2StateAtom = atom((get) => {
    const organizations = get(organizationsV2DataAtom);
    const containersIndex = get(containersIndexV2Atom);
    const defaultOrganizationContainer = get(defaultOrganizationContainerV2Atom);
    const loading = get(organizationsV2LoadingAtom);
    const error = get(organizationsV2ErrorAtom);

    return {
        organizations,
        containersIndex,
        defaultOrganizationContainer,
        loading,
        error,
    };
});

export interface OrganizationsV2State {
    organizations: ResourceContainer[];
    defaultOrganizationContainer: ResourceContainer | undefined;
    containersIndex: Map<string, ResourceContainer>;
    loading: boolean;
    error: Error | undefined;
}
